import { createRequestType } from '../../helpers/requestType';
import { DialogTranscription, Speech, Paginate } from './types';

export const fillTranscriptionsActionType = createRequestType('FILL_TRANSCRIPTIONS');
interface FillTranscriptionsAction {
  type: typeof fillTranscriptionsActionType.request;
  payload: {
      botId: string,
      startDate: string, 
      endDate: string,
      phoneNumber : string
  };
}

interface FillTranscriptionsSuccessAction {
  type: typeof fillTranscriptionsActionType.success;
  payload: Paginate<DialogTranscription>;
}

interface FillTranscriptionsFailureAction {
  type: typeof fillTranscriptionsActionType.failure;
  payload: any;
}

export const fillTranscriptionSpeechActionType = createRequestType('FILL_TRANSCRIPTION_SPEECH');
interface FillTranscriptionSpeechAction {
  type: typeof fillTranscriptionSpeechActionType.request;
  payload: {
      dialogId: string
  };
}

interface FillTranscriptionSpeechSuccessAction {
  type: typeof fillTranscriptionSpeechActionType.success;
  payload: {
    speeches: Speech[],
    dialogId: string
  };
}

interface FillTranscriptionSpeechFailureAction {
  type: typeof fillTranscriptionSpeechActionType.failure;
  payload: any;
}

export const fillTranscriptionActionType = createRequestType('FILL_TRANSCRIPTION');
interface FillTranscriptionAction {
  type: typeof fillTranscriptionActionType.request;
  payload: {
      dialogId: string
  };
}

interface FillTranscriptionSuccessAction {
  type: typeof fillTranscriptionActionType.success;
  payload: {
    transcription: any,
    dialogId: string
  };
}

interface FillTranscriptionFailureAction {
  type: typeof fillTranscriptionActionType.failure;
  payload: any;
}

export type DialogTranscriptionActionTypes =
  | FillTranscriptionsAction
  | FillTranscriptionsSuccessAction
  | FillTranscriptionsFailureAction
  | FillTranscriptionSpeechAction
  | FillTranscriptionSpeechSuccessAction
  | FillTranscriptionSpeechFailureAction
  | FillTranscriptionAction
  | FillTranscriptionSuccessAction
  | FillTranscriptionFailureAction
  ;
